import clientConfig from './config';

/* eslint-disable */
// @ts-ignore
declare let __webpack_public_path__: any;
__webpack_public_path__ = clientConfig.publicPath;
/* eslint-enable */
